import { ICompileService, isArray } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import { RecordDataSource } from "../../../records/grids";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

import {
  FormViewInstanceConfig,
  FormViewService,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
  vsServiceName as FormViewServiceName,
} from "../../../records/forms/formView";

import { ServiceResponse } from "../../../records/server/query";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../ui/authorizedUiElement";
import {
  IExpressionFunction,
  IFieldArray,
  IFieldRuntimeObject,
  ITemplateScope,
  IWatcher,
} from "AngularFormly";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../records/forms/formly/fieldConfigurationHelpers";
import { get, set } from "lodash";
import { LookupManagementService } from "../../../records/lookup/lookupManagement";
import { vsLookupManagementServiceName as LookupManagementServiceName } from "../../shared/configs/lookupManagement";
import { vsObjectName as contactBookTypeName } from "../../shared/configs/lookupManagement/contactBookType";
import { StateParams, StateService } from "@uirouter/angularjs";

export const contactBookConfigViewDefaultSort = "Id";

contactBookConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
  FormViewServiceProviderName,
];

export interface ContactBookEditFormViewConfig extends FormViewInstanceConfig {
  contactBookFieldsEditable?: boolean;
}
const contactBookObjectName = "addressBook";
export const vsObjectName = contactBookObjectName;
export function contactBookConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider,
  formViewServiceProvider: FormViewServiceProvider
) {
  registerGrid(
    recordGridViewServiceProvider,
    columnDefinitionSetServiceProvider
  );
  registerForm(formViewServiceProvider);
}

function registerGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    ColumnDefinitionSetServiceName,

    (columnDefinitionService: ColumnDefinitionService) => [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookTitle",
        header: "Title",
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookTypeName",
        header: "Type",
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookName",
        header: "Contact Name",
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookBusinessName",
        header: "Business Name",
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookContact",
        header: "Phone Number",
        //valueGetter: telephoneValueGetter,
        //csvValueGetter: defaultValueGetterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookEmail",
        header: "Email address",
        //valueGetter: emailValueGetter,
        //csvValueGetter: defaultValueGetterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookCellPhone",
        header: "Cell Phone",
        //valueGetter: telephoneValueGetter,
        //csvValueGetter: defaultValueGetterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookAddress",
        header: "Address",
      }),
      columnDefinitionService.getStringColDef({
        field: "AddressBookNotes",
        header: "Notes",
      }),
    ],
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      return {
        columnDefinitionSet: vsObjectName,
        defaultSort: contactBookConfigViewDefaultSort,
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/addressBook/addressBook"
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        nameSingular: "Contact Book",
        namePlural: "Contact Books",
        showAddButton: true,
      };
    },
  ]);
}

function registerForm(formViewServiceProvider: FormViewServiceProvider) {
  formViewServiceProvider.addFormViewConfig(vsObjectName, [
    FormViewServiceName,
    FieldConfigurationHelperServiceName,
    LookupManagementServiceName,
    RecordGridViewServiceName,
    "$state",
    (
      formViewService: FormViewService,
      fieldConfigurationHelperService: FieldConfigurationHelperService,
      lookupManagementService: LookupManagementService,
      recordGridViewService: RecordGridViewService,
      $state: StateService
    ) => {
      return {
        fields: <IFieldArray>[
          ...fieldHelpers.columnLayout(
            [
              fieldHelpers.simpleStringField({
                key: "Title",
                name: "Title",
                label: "Title ",
                required: true,
              }),
              fieldConfigurationHelperService.lookupField(
                lookupManagementService,
                {
                  objectName: contactBookTypeName,
                  key: "AddressBookTypeId",
                }
              ),

              fieldHelpers.simpleStringField({
                key: "Name",
                name: "Name",
                label: "Contact Name",
                required: true,
              }),
              fieldHelpers.simpleStringField({
                key: "BusinessName",
                name: "BusinessName",
                label: "Business Name ",
              }),
              fieldHelpers.simpleStringField({
                key: "Email",
                name: "Email",
                label: "Email address ",
              }),
              fieldHelpers.simpleStringField({
                key: "Contact",
                name: "Contact",
                label: "Phone Number",
              }),
              fieldHelpers.simpleStringField({
                key: "CellPhone",
                name: "CellPhone",
                label: "Cell Phone ",
              }),
            ],
            4
          ),
          ...fieldHelpers.columnLayout(
            [
              fieldHelpers.textAreaField({
                key: "Address",
                name: "Address",
                label: "Address",
                rows: 3,
              }),
            ],
            1
          ),
          fieldHelpers.headerField({
            headerText: "Notes",
            key: "NotesHeader",
          }),
          ...fieldHelpers.columnLayout(
            [
              fieldHelpers.textAreaField({
                key: "Notes",
                name: "Notes",
                label: " ",
                rows: 5,
              }),
            ],
            1
          ),
        ],
        name: vsObjectName,
        submitForm: (args) =>
          formViewService
            .saveForm({
              formObject: args.model,
              formViewController: args.formViewController,
              url: "/api/addressBook/AddressBook",
            })
            .then((result: any) => $state.go("main.contactBook.grid")),
        title: () => "Contact Book",
        showButtonsAtTop: true,
      };
    },
  ]);
}
